// extracted by mini-css-extract-plugin
module.exports = {"Input":"orderInstall_Input___k6aq"};